/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The ModelCommon model module.
* @module model/ModelCommon
* @version 2020-12-7
*/
export default class ModelCommon {
    /**
    * Constructs a new <code>ModelCommon</code>.
    * @alias module:model/ModelCommon
    * @class
    * @param updatedAt {Number} 最終更新時刻(epoch秒)
    */

    constructor(updatedAt) {
        
        
        this['updatedAt'] = updatedAt;
        
    }

    /**
    * Constructs a <code>ModelCommon</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/ModelCommon} obj Optional instance to populate.
    * @return {module:model/ModelCommon} The populated <code>ModelCommon</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ModelCommon();
                        
            
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Number');
            }
        }
        return obj;
    }

    /**
    * 最終更新時刻(epoch秒)
    * @member {Number} updatedAt
    */
    'updatedAt' = undefined;




}
